import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { USER_ROLE_TYPE_EXTERNAL, UserRole } from 'src/app/models/common/user-role';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { InviteModelForLeadVerification, LeadInviteModelErrors } from '../lead-verification/lead-invite.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { DomainCodeApiService } from 'src/app/services/domain_code/domain-code-api.service';
import { UserMasterApiService } from 'src/app/services/domain_code/user-master-api.service';
import { MyTeamService } from '../../my-account/my-team/my-team.service';
import { VerifyCustomerService } from '../verify-customer.service';
import { BackendListModel } from 'src/app/models/common/list.model';
import { RejectionReasonModel } from 'src/app/models/common/myteam-model';
import { BehaviorSubject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { WarningBoxComponent } from '../../dialog-box/warning-box/warning-box.component';

@Component({
    selector: 'logzy-user-verification',
    templateUrl: './user-verification.component.html',
    styleUrls: ['./user-verification.component.scss']
})
export class UserVerificationComponent implements OnInit {
    @Input()
    getAddedCompany = new BehaviorSubject(null);

    @Output()
    newCompanyData = new EventEmitter();

    isEditable: boolean = true;
    userObj: InviteModelForLeadVerification = new InviteModelForLeadVerification();
    rejectionReasonList: BackendListModel<RejectionReasonModel>;
    profileRoleList: BackendListModel<UserRole>;

    country_url: string = `${ApiRoutes.Geo}country/?name=::search::`;
    state_url: string = `${ApiRoutes.Geo}state/?name=::search::`;
    company_url = `${ApiRoutes.Company}company/?search=::search::`;

    constructor(private route: ActivatedRoute,
        private verifyCustomerService: VerifyCustomerService,
        private myTeamService: MyTeamService,
        private snackBar: MatSnackBar,
        private userService: UserMasterApiService,
        private router: Router,
        private dialog: MatDialog
    ) { }

    ngOnInit(): void {
        this.resetComponent();

        this.getAddedCompany.subscribe(item => {
            if (item != null) {
                this.userObj.company = item;
            }
        });
    }

    closeDetails() {
        this.router.navigateByUrl(`verify-customer`);
    }
    resetComponent() {
        this.userObj = new InviteModelForLeadVerification();
        this.getRejectionReasonList();
        this.getProfileRoleList();
        this.route.queryParams.subscribe(params => {
            if ('id' in params) {
                this.getUserById(params['id']);
            }
        });
    }

    getUserById(user_id) {
        this.verifyCustomerService.getUserById(user_id).subscribe({
            next: res => {
                if (res.approval_status == 'company_unassigned') {
                    this.userObj.saveFirstPayload(res);
                } else {
                    this.userObj = new InviteModelForLeadVerification(res);
                    this.isEditable = false;
                }
                setTimeout(() => {
                    this.setRole();
                    this.userObj.country = this.userObj.state.country;
                    this.state_url = `${ApiRoutes.Geo}state/?name=::search::&country=${this.userObj.state.country.id}`;
                }, 100);
            },
            error: err => {
                console.log(err);
            }
        });
    }

    setRole() {
        for (let i = 0; i < this.profileRoleList.results.length; i++) {
            if (this.profileRoleList.results[i].name == 'Admin') {
                this.userObj.role = this.profileRoleList?.results[i];
            }
        }
    }

    getRejectionReasonList() {
        this.myTeamService.getRejectionReason().subscribe({
            next: response => {
                this.rejectionReasonList = response;
            },
            error: error => {
                console.log(error)
                return error;
            }
        });
    }

    getProfileRoleList() {
        this.userService.getRoleByType(USER_ROLE_TYPE_EXTERNAL).subscribe({
            next: response => {
                this.profileRoleList = response;
            },
            error: error => {
                console.log(error)
                return error;
            }
        });
    }

    filterStates(country) {
        if (country != null) {
            if (country.id != this.userObj.country?.id) {
                this.userObj.country = country;
                this.userObj.state = null;
                this.state_url = `${ApiRoutes.Geo}state/?name=::search::&country=${country.id}`;
            }
        } else {
            this.userObj.country = null;
            this.userObj.state = null;
        }
    }

    setRemarks(event) {
        if (event != null) {
            this.userObj.is_login_approved = event
            this.userObj.remarks = event ? 'Approved' : 'Rejected';
        }
    }

    submitUserApproval() {
        if (this.userObj.is_user_valid()) {
            this.verifyCustomerService.putUser(this.userObj.getUserVerificationSavePayload(), this.userObj.id).subscribe({
                next: res => {
                    this.snackBarMessage();
                    setTimeout(() => {
                        this.router.navigate(['/verify-customer']);
                    }, 1000);
                    console.log(res);
                },
                error: err => {
                    if (err.error.role) {
                        this.openWarning(`${err.error.role}`, '', 'I Understand');
                    }
                    this.userObj.error = { ...err.error };
                    console.log(err);
                }
            });
        }
    }

    getCompanyDetails(event) {
        if (event != null) {
            if (event.id != null) {
                this.userObj.company = event;
                return;
            }
            if (typeof event == 'object') {
                let data = {
                    name: event?.legal_name,
                    country: this.userObj?.country,
                    state: this.userObj?.state,
                    address: this.userObj?.address,
                }
                this.newCompanyData.emit(data);
            }
        }
    }

    snackBarMessage() {
        // if (this.userObj.is_login_approved) {
        //     this.snackBar.open("User Verified!", 'Close', {
        //         verticalPosition: 'top',
        //         duration: 2000,
        //     });
        // } else {
        //     this.snackBar.open("User Login Rejected!", 'Close', {
        //         verticalPosition: 'top',
        //         duration: 2000,
        //     });
        // }

        if (this.userObj.is_login_approved=='yes') {
            this.snackBar.open("User Approved!", 'Close', {
                verticalPosition: 'top',
                duration: 2000,
            });
        }
        else if (this.userObj.is_login_approved=='no'){
            this.snackBar.open("User Rejected!", 'Close', {
                verticalPosition: 'top',
                duration: 2000,
            });
        }
        else if (this.userObj.is_login_approved=='under_process'){
            this.snackBar.open("User In Process!", 'Close', {
                verticalPosition: 'top',
                duration: 2000,
            });
        }
        else{
            this.snackBar.open("User Pending!", 'Close', {
                verticalPosition: 'top',
                duration: 2000,
            });  
        }
    }
    openWarning(label: string, description, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: { subTitle: label, parent: this, description: description, label1: action1, label2: action2 }
        });
    }
}
